import React, { lazy } from 'react';
import { Route, useRouteMatch, Switch } from 'react-router-dom';

const ServiciosView = lazy(() => import('../../container/administracion/servicios/Index'));
const ServiciosForm = lazy(() => import('../../container/administracion/servicios/Form'));

const ServiciosRoute = () => {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <Route path={`${path}/servicios/listado`} component={ServiciosView} />      
      <Route path={`${path}/servicios/agregar`} component={ServiciosForm} />
      <Route exact path={`${path}/servicios/editar/:id`} component={ServiciosForm} />
  {/*<Route exact path={`${path}/sucursales/unidades-medicas/:id/:nombre`} component={UnidadesMedicas} />
  */}
    </Switch>
  );
};

export default ServiciosRoute;

